import { Inject, Injectable } from '@angular/core';
import { CheckoutFacade } from '@checkout/data-access';
import {
  CheckoutCardConfig,
  CheckoutCardProvider,
  CHECKOUT_CARD_CONFIG,
  CmsCardPage,
} from '@checkout/util-models';
import { CmsContainer } from '@domgen/dgx-fe-cms';
import { PaymentType } from '@domgen/dgx-fe-common';
import { combineLatest, Observable, of } from 'rxjs';

export interface ViewModel {
  cardProvider: CheckoutCardProvider;
  cmsData: CmsCardPage;
}

@Injectable()
export class CardComponentService {
  readonly vm$: Observable<ViewModel> = combineLatest({
    cardProvider: of(this.checkoutCardConfig.provider),
    cmsData: this.cmsContainer.content$,
  });

  constructor(
    @Inject(CHECKOUT_CARD_CONFIG)
    private readonly checkoutCardConfig: CheckoutCardConfig,
    private readonly checkoutFacade: CheckoutFacade,
    private readonly cmsContainer: CmsContainer<CmsCardPage>
  ) {}

  onFormSubmit(cardPaymentReference: string): void {
    this.checkoutFacade.checkoutRequest({
      cardPaymentReference,
      paymentType: PaymentType.Card,
    });
  }
}
